import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {Ranges, Range} from "../range";

export abstract class RangesService {

    private allRangesMap: Map<number,  Array<Range>> = new Map<number, Array<Range>>();

    constructor(private _http: HttpClient, private context) {
    }

    getAllRangesByGroupId(groupId: number): Observable<Array<Range>> {
        return this.getRanges(`/api/${this.context}/dictionary/ranges/${groupId}`, groupId, this.allRangesMap);
    }

    private getRanges(url: string, groupId: number, cache:  Map<number, Array<Range>>): Observable<Array<Range>> {
        if (cache.has(groupId)) {
            return Observable.of(cache.get(groupId));
        }

        return this._http.get<Ranges>(url)
            .map(response => {
                let ranges = response.ranges;
                cache.set(groupId, ranges);
                return ranges;
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/ranges.service.ts